import { useSelector } from 'react-redux'
import SearchForm from './SearchHead/SearchForm'
import SearchLabels from './SearchResult/SearchLabels'

const SearchHead = () => {
  const description = useSelector((state) => state.items.description || '...')
  const title = useSelector(
    (state) =>
      state.items.headTitle || I18n.t('cars.index.search_for_classic_car')
  )

  return (
    <div className="mt-6 mb-3">
      <Heading title={title} description={description} />
      <SearchForm />
      <SearchLabels />
    </div>
  )
}

const Heading = ({ title, description }) => {
  const textLength = 100
  const getTruncatedDescription = (text, length) => {
    return text.length > length ? `${text.substring(0, length)}...` : text
  }

  const truncatedDescription = getTruncatedDescription(description, textLength)

  return (
    <header>
      <h1>{title}</h1>
      <h2 className="show-more-description lead mb-5">
        {description.length > textLength ? truncatedDescription : description}
      </h2>
    </header>
  )
}

export default SearchHead
